export enum FhirQuestionnaireStatus {
    draft = 'draft',
    active = 'active',
    retired = 'retired',
    unknown = 'unknown',
}
